import React, { useEffect, useState } from "react";
import {
  Box,
  Card,
  CardContent,
  Typography,
  TextField,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  Button,
  IconButton,
  Stepper,
  Step,
  StepLabel,
  Grid,
  Fade,
  Chip,
  Alert,
  Divider,
  Autocomplete,
  useTheme,
  alpha
} from "@mui/material";
import {
  Business as BusinessIcon,
  LocationOn as LocationIcon,
  Home as HomeIcon,
  Email as EmailIcon,
  Add as AddIcon,
  Remove as RemoveIcon,
  Save as SaveIcon,
  ArrowForward as ArrowForwardIcon,
  AccountBalance as BankIcon,
   ArrowBack as ArrowBackIcon,
  Place as PlaceIcon
} from "@mui/icons-material";
import PlacesAutocomplete, { geocodeByAddress } from 'react-places-autocomplete';
import styled from 'styled-components';
import { apiCall } from "../../../services/ApiCall";
import config from "../../../config/config.json";
import { useNavigate } from "react-router-dom";

// Styled Components
const StyledContainer = styled(Box)`
 
  min-height: 100vh;
  padding: 24px;
`;
const HeaderWrapper = styled(Box)`
  margin-bottom: 24px;
  padding: 0 16px; 

`;

const FormCard = styled(Card)`
  background: rgba(255, 255, 255, 0.95) !important;
  backdrop-filter: blur(20px);
  border-radius: 20px !important;
  box-shadow: 0 8px 32px rgba(243, 243, 243, 1) !important;
  border: 1px solid rgba(13, 110, 253, 0.08);
  margin-bottom: 20px;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;
  
  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 12px 40px rgba(243, 243, 243, 1) !important;
  }
`;

const StyledTextField = styled(TextField)`
  .MuiOutlinedInput-root {
    border-radius: 12px !important;
    background: rgba(255, 255, 255, 0.9);
    transition: all 0.3s ease !important;
    
    &:hover {
      background: rgba(255, 255, 255, 1);
      box-shadow: 0 4px 12px rgba(243, 243, 243, 1);
    }
    
    &.Mui-focused {
      background: rgba(255, 255, 255, 1);
      box-shadow: 0 0 0 2px rgba(243, 243, 243, 1);
    }
  }
  
  .MuiInputLabel-root {
    font-weight: 500;
    
    &.Mui-focused {
      color: #0d6efd;
    }
  }
`;

const StyledFormControl = styled(FormControl)`
  .MuiOutlinedInput-root {
    border-radius: 12px !important;
    background: rgba(255, 255, 255, 0.9);
    transition: all 0.3s ease !important;
    
    &:hover {
      background: rgba(255, 255, 255, 1);
      box-shadow: 0 4px 12px rgba(243, 243, 243, 1);
    }
    
    &.Mui-focused {
      background: rgba(255, 255, 255, 1);
      box-shadow: 0 0 0 2px rgba(243, 243, 243, 1);
    }
  }
  
  .MuiInputLabel-root {
    font-weight: 500;
    
    &.Mui-focused {
      color: #0d6efd;
    }
  }
`;

const ActionButton = styled(Button)`
  border-radius: 12px !important;
  padding: 12px 32px !important;
  font-weight: 600 !important;
  text-transform: none !important;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;
  
  &:hover {
    transform: translateY(-2px);
  }
`;

const LenderCard = styled(Card)`
  background: rgba(248, 250, 255, 0.8) !important;
  border-radius: 16px !important;
  border: 1px solid rgba(13, 110, 253, 0.1) !important;
  margin-bottom: 16px;
  transition: all 0.3s ease !important;
  
  &:hover {
    background: rgba(248, 250, 255, 1) !important;
    transform: translateY(-2px);
    box-shadow: 0 8px 25px rgba(243, 243, 243, 1) !important;
  }
`;

const PlacesAutocompleteWrapper = styled.div`
  position: relative;
  
  .places-input {
    width: 100%;
    padding: 16.5px 14px;
    border: 1px solid rgba(0, 0, 0, 0.23);
    border-radius: 12px;
    background: rgba(255, 255, 255, 0.9);
    font-size: 16px;
    transition: all 0.3s ease;
    
    &:hover {
      background: rgba(255, 255, 255, 1);
      box-shadow: 0 4px 12px rgba(243, 243, 243, 1);
    }
    
    &:focus {
      outline: none;
      border-color: #0d6efd;
      box-shadow: 0 0 0 2px rgba(243, 243, 243, 1);
      background: rgba(255, 255, 255, 1);
    }
  }
  
  .suggestions-container {
    position: absolute;
    top: 100%;
    left: 0;
    right: 0;
    z-index: 1000;
    background: white;
    border-radius: 12px;
    box-shadow: 0 8px 32px rgba(243, 243, 243, 1);
    border: 1px solid rgba(13, 110, 253, 0.1);
    max-height: 200px;
    overflow-y: auto;
  }
  
  .suggestion-item {
    padding: 12px 16px;
    cursor: pointer;
    transition: background-color 0.2s ease;
    
    &:hover, &.active {
      background-color: rgba(13, 110, 253, 0.08);
    }
    
    &:first-child {
      border-top-left-radius: 12px;
      border-top-right-radius: 12px;
    }
    
    &:last-child {
      border-bottom-left-radius: 12px;
      border-bottom-right-radius: 12px;
    }
  }
`;

const CompanyDetail = ({ onSwitchToContact, answer, setAnswer }) => {
  const navigate = useNavigate();
  const theme = useTheme();
  const [data, setData] = useState([]);
  const [isDisabled, setIsDisabled] = useState(false);
  const [saving, setSaving] = useState(false);
  const [errors, setErrors] = useState({
    araId: '',
    name: '',
    street: '',
    city: '',
    state: '',
    zipcode: ''
  });

  const [lenders, setLenders] = useState([{ lenderName: '', lenderEmail: '' }]);

  const validateAraId = (araId) => {
    return araId.trim() === '' ? 'ARA ID is required' : '';
  };

  const validateName = (name) => {
    return name.trim() === '' ? 'Company Name is required' : '';
  };

  const validateStreet = (street) => {
    return street.trim() === '' ? 'Street is required' : '';
  };

  const validateCity = (city) => {
    return city.trim() === '' ? 'City is required' : '';
  };

  const validateState = (state) => {
    return state.trim() === '' ? 'State is required' : '';
  };

  const validateZipcode = (zipcode) => {
    return zipcode.trim() === '' ? 'Zipcode is required' : '';
  };

  const handleValidation = () => {
    const araIdError = validateAraId(answer.araId);
    const nameError = validateName(answer.name);
    const streetError = validateStreet(answer.street);
    const cityError = validateCity(answer.city);
    const stateError = validateState(answer.state);
    const zipcodeError = validateZipcode(answer.zipcode);

    setErrors({
      araId: araIdError,
      name: nameError,
      street: streetError,
      city: cityError,
      state: stateError,
      zipcode: zipcodeError
    });

    return !araIdError && !nameError && !streetError && !cityError && !stateError && !zipcodeError;
  };

  const addNewCompanyAndContact = async (e) => {
    e.preventDefault();
    setSaving(true);
    const updatedAnswer = { ...answer, userData: [] };
    const { isSuccess } = await apiCall(
      `${config.POST_LOGIN_API_URL}addNewCompanyAndContact`,
      {},
      updatedAnswer,
      "POST"
    );
    setSaving(false);
    if (isSuccess) {
      navigate("/company-list");
    }
  };

  const changeName = (e) => {
    setAnswer((prevAnswer) => ({
      ...prevAnswer,
      name: e.target.value,
    }));
  };

  const changeAraId = (e) => {
    setAnswer((prevAnswer) => ({
      ...prevAnswer,
      araId: e.target.value,
    }));

    if (data.includes(e.target.value)) {
      setErrors((prevErrors) => ({
        ...prevErrors,
        araId: 'This ARA ID already exists.',
      }));
      setIsDisabled(true);
    } else {
      setErrors((prevErrors) => ({
        ...prevErrors,
        araId: null,
      }));
      setIsDisabled(false);
    }
  };

  const changeStreet2 = (e) => {
    setAnswer((prevAnswer) => ({
      ...prevAnswer,
      street2: e.target.value,
    }));
  };

  const changeCity = (e) => {
    setAnswer((prevAnswer) => ({
      ...prevAnswer,
      city: e.target.value,
    }));
  };

  const changeState = (e) => {
    setAnswer((prevAnswer) => ({
      ...prevAnswer,
      state: e.target.value,
    }));
  };

  const changeZipcode = (e) => {
    setAnswer((prevAnswer) => ({
      ...prevAnswer,
      zipcode: e.target.value,
    }));
  };

  const changeOfficeType = (e) => {
    setAnswer((prevAnswer) => ({
      ...prevAnswer,
      officeType: e.target.value,
    }));
  };

  const getCompanyList = async () => {
    const { isSuccess, data } = await apiCall(
      `${config.POST_LOGIN_API_URL}getCompanyList`,
      {},
      {},
      "GET"
    );
    if (isSuccess) {
      setData([...new Set(data?.data?.map(item => item.araId))]);
    }
  };

  useEffect(() => {
    getCompanyList();
  }, []);

  const handleSelect = async (address) => {
    try {
      const results = await geocodeByAddress(address);
      const addressComponents = results[0].address_components;
      const getAddressComponent = (types) => {
        const component = addressComponents.find(comp => types.some(type => comp.types.includes(type)));
        return component ? component.long_name : '';
      };

      const street = getAddressComponent(['street_number']) + ' ' + getAddressComponent(['route']);
      const city = getAddressComponent(['locality']);
      const state = getAddressComponent(['administrative_area_level_1']);
      const zipcode = getAddressComponent(['postal_code']);
      setAnswer(prevAnswer => ({
        ...prevAnswer,
        street: street || address,
        city,
        state,
        zipcode
      }));
    } catch (error) {
      console.error("Error fetching address details: ", error);
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (handleValidation()) {
      onSwitchToContact();
    }
  };

  const addLender = () => {
    setLenders([...lenders, { lenderName: '', lenderEmail: '' }]);
  };

  const removeLender = (index) => {
    const updatedLenders = lenders.filter((_, i) => i !== index);
    setLenders(updatedLenders);
  };

  const handleLenderChange = (index, field, value) => {
    const updatedLenders = [...lenders];
    updatedLenders[index][field] = value;
    setLenders(updatedLenders);
  };

  return (
    <StyledContainer>
      {/* Header Section */}
        <HeaderWrapper>
             <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
               <IconButton 
                 onClick={onSwitchToContact}
                 sx={{ mr: 1 }} 
               >
                 <ArrowBackIcon />
               </IconButton>
               <Typography variant="h5" sx={{ fontWeight: 'bold' }}>
                 Add Company
               </Typography>
             </Box>
           
             <Box>
               <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 0.5 }}>
                 <Typography variant="body2" sx={{ fontWeight: 'medium', color: 'text.primary' }}>
                   Step 1 of 2
                 </Typography>
                 <Typography variant="body2" sx={{ color: 'text.secondary' }}>
                   Company Details
                 </Typography>
               </Box>
               <Box sx={{ flexGrow: 1, height: '8px', background: alpha('#0d6efd', 0.2), borderRadius: '4px', overflow: 'hidden' }}>
                 <Box sx={{ width: '50%', height: '100%', background: '#0d6efd', borderRadius: '4px' }} /> 
               </Box>
             </Box>
           </HeaderWrapper>

      <form onSubmit={handleSubmit}>
        {/* Company Information */}
        <Fade in timeout={500}>
          <FormCard>
            <CardContent sx={{ p: 3 }}>
              <Box sx={{ display: 'flex', alignItems: 'center', mb: 3 }}>
              
                <Typography variant="h6" sx={{ fontWeight: 600, color: '#1a202c' }}>
                  Company Information
                </Typography>
              </Box>

              <Divider sx={{ mb: 3, borderColor: alpha('#0d6efd', 0.1) }} />

              <Grid container spacing={3}>
              <Grid item xs={12} md={6}>
  <Box>
    <Typography variant="body2" sx={{ mb: 1, fontWeight: 500,ml:1 }}>
      ARA ID <span style={{ color: 'red' }}>*</span>
    </Typography>
    <StyledTextField
      fullWidth
      placeholder="Enter ARA ID"
      value={answer.araId || ''}
      onChange={changeAraId}
      error={!!errors.araId}
      helperText={errors.araId}
      InputProps={{
        startAdornment: (
          <BusinessIcon sx={{ color: '#64748b', mr: 1 }} />
        ),
      }}
      required
    />
  </Box>
</Grid>

                <Grid item xs={12} md={6}>
  <Box>
    <Typography variant="body2" sx={{ mb: 1, fontWeight: 500 ,ml:1}}>
      Company Name <span style={{ color: 'red' }}>*</span>
    </Typography>
    <StyledTextField
      fullWidth
      placeholder="Enter Company Name"
      value={answer.name || ''}
      onChange={changeName}
      error={!!errors.name}
      helperText={errors.name}
      InputProps={{
        startAdornment: (
          <BusinessIcon sx={{ color: '#64748b', mr: 1 }} />
        ),
      }}
      required
    />
  </Box>
</Grid>
              </Grid>
            </CardContent>
          </FormCard>
        </Fade>

        {/* Address Information */}
        <Fade in timeout={700}>
          <FormCard>
            <CardContent sx={{ p: 3 }}>
              <Box sx={{ display: 'flex', alignItems: 'center', mb: 3 }}>
                <LocationIcon sx={{ color: '#0d6efd', mr: 2, fontSize: 28 }} />
                <Typography variant="h6" sx={{ fontWeight: 600, color: '#1a202c' }}>
                  Address Information
                </Typography>
              </Box>

              <Divider sx={{ mb: 3, borderColor: alpha('#0d6efd', 0.1) }} />

              <Grid container spacing={3}>
                <Grid item xs={12} md={6}>
                  <Box>
                    <Typography 
                      variant="body2" 
                      sx={{ 
                        mb: 1, 
                        fontWeight: 500, 
                        color: '#64748b',
                        display: 'flex',
                        alignItems: 'center'
                      }}
                    >
                      <PlaceIcon sx={{ mr: 1, fontSize: 20 }} />
                      Street Address *
                    </Typography>
                    <PlacesAutocompleteWrapper>
                      <PlacesAutocomplete
                        value={answer.street || ''}
                        onChange={(value) => setAnswer({ ...answer, street: value })}
                        onSelect={handleSelect}
                      >
                        {({ getInputProps, suggestions, getSuggestionItemProps, loading }) => (
                          <div>
                            <input 
                              {...getInputProps({ 
                                placeholder: 'Start typing to search for address',
                                className: 'places-input'
                              })} 
                            />
                            {(suggestions.length > 0 || loading) && (
                              <div className="suggestions-container">
                                {loading && (
                                  <div style={{ padding: '12px 16px', color: '#64748b' }}>
                                    Loading...
                                  </div>
                                )}
                                {suggestions.map((suggestion, index) => (
                                  <div
                                    key={index}
                                    {...getSuggestionItemProps(suggestion, {
                                      className: `suggestion-item ${suggestion.active ? 'active' : ''}`
                                    })}
                                  >
                                    {suggestion.description}
                                  </div>
                                ))}
                              </div>
                            )}
                          </div>
                        )}
                      </PlacesAutocomplete>
                    </PlacesAutocompleteWrapper>
                    {errors.street && (
                      <Typography variant="caption" sx={{ color: 'error.main', mt: 0.5, ml: 2 }}>
                        {errors.street}
                      </Typography>
                    )}
                  </Box>
                </Grid>

               <Grid item xs={12} md={6}>
  <Box>
    <Typography variant="body2" sx={{ mb: 1, fontWeight: 500, ml: 1 }}>
      Street Address 2
    </Typography>
    <StyledTextField
      fullWidth
      placeholder="Apartment, suite, etc. (optional)"
      value={answer.street2 || ''}
      onChange={changeStreet2}
      InputProps={{
        startAdornment: (
          <HomeIcon sx={{ color: '#64748b', mr: 1 }} />
        ),
      }}
    />
  </Box>
</Grid>

                <Grid item xs={12} md={4}>
  <Box>
    <Typography variant="body2" sx={{ mb: 1, fontWeight: 500, ml: 1 }}>
      City <span style={{ color: 'red' }}>*</span>
    </Typography>
    <StyledTextField
      fullWidth
      placeholder="Enter City"
      value={answer.city || ''}
      onChange={changeCity}
      error={!!errors.city}
      helperText={errors.city}
      required
    />
  </Box>
</Grid>
<Grid item xs={12} md={4}>
  <Box>
    <Typography variant="body2" sx={{ mb: 1, fontWeight: 500, ml: 1 }}>
      State <span style={{ color: 'red' }}>*</span>
    </Typography>
    <StyledTextField
      fullWidth
      placeholder="Enter State"
      value={answer.state || ''}
      onChange={changeState}
      error={!!errors.state}
      helperText={errors.state}
      required
    />
  </Box>
</Grid>
<Grid item xs={12} md={4}>
  <Box>
    <Typography variant="body2" sx={{ mb: 1, fontWeight: 500, ml: 1 }}>
      ZIP Code <span style={{ color: 'red' }}>*</span>
    </Typography>
    <StyledTextField
      fullWidth
      placeholder="Enter ZIP Code"
      value={answer.zipcode || ''}
      onChange={changeZipcode}
      error={!!errors.zipcode}
      helperText={errors.zipcode}
      required
    />
  </Box>
</Grid>
<Grid item xs={12} md={6}>
  <Box>
    <Typography variant="body2" sx={{ mb: 1, fontWeight: 500, ml: 1 }}>
      Type
    </Typography>
    <StyledFormControl fullWidth>
      <Select
        value={answer.officeType || 'Head Office'}
        onChange={changeOfficeType}
        displayEmpty
        renderValue={(value) => value || 'Select Type'}
      >
        <MenuItem value="Head Office">Head Office</MenuItem>
      </Select>
    </StyledFormControl>
  </Box>
</Grid>
              </Grid>
            </CardContent>
          </FormCard>
        </Fade>

        {/* Lender Information */}
        <Fade in timeout={900}>
          <FormCard>
            <CardContent sx={{ p: 3 }}>
              <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                  <BankIcon sx={{ color: '#0d6efd', mr: 2, fontSize: 28 }} />
                  <Typography variant="h6" sx={{ fontWeight: 600, color: '#1a202c' }}>
                    Lender Information
                  </Typography>
                  <Chip 
                    label="Optional"
                    size="small"
                    sx={{ 
                      ml: 2,
                      background: alpha('#64748b', 0.1),
                      color: '#64748b',
                      fontWeight: 500
                    }}
                  />
                </Box>

                <Button
                  variant="outlined"
                  startIcon={<AddIcon />}
                  onClick={addLender}
                  sx={{
                    borderColor: '#0d6efd',
                    color: '#0d6efd',
                    borderRadius: '12px',
                    '&:hover': {
                      background: alpha('#0d6efd', 0.05),
                      transform: 'scale(1.02)'
                    }
                  }}
                >
                  Add Lender
                </Button>
              </Box>

              <Divider sx={{ mb: 3, borderColor: alpha('#0d6efd', 0.1) }} />

              {lenders.map((lender, index) => (
                <LenderCard key={index}>
                  <CardContent sx={{ p: 2 }}>
                    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
                      <Typography variant="subtitle1" sx={{ fontWeight: 600, color: '#1a202c' }}>
                        Lender {index + 1}
                      </Typography>
                      {index > 0 && (
                        <IconButton
                          onClick={() => removeLender(index)}
                          size="small"
                          sx={{
                            color: '#f44336',
                            '&:hover': {
                              background: alpha('#f44336', 0.1),
                              transform: 'scale(1.1)'
                            }
                          }}
                        >
                          <RemoveIcon />
                        </IconButton>
                      )}
                    </Box>

                    <Grid container spacing={2}>
                     <Grid item xs={12} md={6}>
  <Box>
    <Typography variant="body2" sx={{ mb: 1, fontWeight: 500, ml: 1 }}>
      Lender Name
    </Typography>
    <StyledTextField
      fullWidth
      placeholder="Enter Lender Name"
      value={lender.lenderName}
      onChange={(e) => handleLenderChange(index, 'lenderName', e.target.value)}
      InputProps={{
        startAdornment: (
          <BankIcon sx={{ color: '#64748b', mr: 1 }} />
        ),
      }}
    />
  </Box>
</Grid>

                      <Grid item xs={12} md={6}>
  <Box>
    <Typography variant="body2" sx={{ mb: 1, fontWeight: 500, ml: 1 }}>
      Lender Email
    </Typography>
    <StyledTextField
      fullWidth
      type="email"
      placeholder="Enter Lender Email"
      value={lender.lenderEmail}
      onChange={(e) => handleLenderChange(index, 'lenderEmail', e.target.value)}
      InputProps={{
        startAdornment: (
          <EmailIcon sx={{ color: '#64748b', mr: 1 }} />
        ),
      }}
    />
  </Box>
</Grid>
                    </Grid>
                  </CardContent>
                </LenderCard>
              ))}
            </CardContent>
          </FormCard>
        </Fade>

        {/* Error Alert */}
        {Object.values(errors).some(error => error) && (
          <Alert severity="error" sx={{ mb: 3, borderRadius: '12px' }}>
            Please correct the errors above before proceeding.
          </Alert>
        )}

        {/* Action Buttons */}
        <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 2, mt: 3 }}>
          <ActionButton
            variant="outlined"
            startIcon={<SaveIcon />}
            onClick={addNewCompanyAndContact}
            disabled={isDisabled || saving}
            sx={{
              borderColor: '#64748b',
              color: '#64748b',
              '&:hover': {
                borderColor: '#0d6efd',
                color: '#0d6efd',
                background: alpha('#0d6efd', 0.05)
              }
            }}
          >
            {saving ? 'Saving...' : 'Save'}
          </ActionButton>

          <ActionButton
            type="submit"
            variant="contained"
            endIcon={<ArrowForwardIcon />}
            disabled={isDisabled || saving}
            sx={{
              background: 'linear-gradient(135deg, #0d6efd 0%, #0a58ca 100%)',
              '&:hover': {
                background: 'linear-gradient(135deg, #0a58ca 0%, #084298 100%)',
                boxShadow: '0 8px 25px rgba(13, 110, 253, 0.3)'
              }
            }}
          >
            Next
          </ActionButton>
        </Box>
      </form>
    </StyledContainer>
  );
};

export default CompanyDetail;